module.exports = __webpack_public_path__ + "img/st-02.prt.3d4a3f06.jpg";